import { getRandomId } from '@merels/game-logic'

/**
 * Gets or generates a unique client ID for the current session.
 * Uses sessionStorage to ensure that each tab has a unique ID,
 * which is necessary for multiple tabs to act as separate mates
 * in the same room.
 */
export function getOrGenerateClientId(): string {
  if (typeof window === 'undefined') return 'server-client'
  
  const STORAGE_KEY = 'merels_clientId'
  const savedClientId = window.sessionStorage.getItem(STORAGE_KEY)

  if (savedClientId) {
    return savedClientId
  } else {
    const clientId = getRandomId(8)
    window.sessionStorage.setItem(STORAGE_KEY, clientId)
    return clientId
  }
}
